import { failureToMessage } from "@/modules/billing/payment/paymentUtils.ts";
import { SimpleLocalizedError, type Localizable } from "@/modules/l10n/getTransText.ts";
import { msg } from "@lingui/core/macro";
import type { PersistentDataResponse } from "@warrenio/api-spec/spec.oats.gen";
import type { EmptyObject, LiteralUnion } from "type-fest";

export interface SslcommerzChargeData {
    status?: "VALID" | "HIGH_RISK" | "CANCELLED";
    amount_without_vat: number;
    amount_with_vat: number;
    currency: string;

    failure_code?: LiteralUnion<"payment_cancelled" | "high_risk", string>;
    failure_message?: string;
}

/** @public */
export class SslcommerzError extends SimpleLocalizedError {
    name = "SslcommerzError";

    constructor(
        public readonly code: "payment_cancelled" | "high_risk" | "other",
        localeMessage: Localizable,
    ) {
        super(localeMessage);
    }
}

export function parseSslcommerzPersistentData(response: PersistentDataResponse) {
    const data = JSON.parse(response.data) as SslcommerzChargeData | EmptyObject;
    if (!("status" in data)) {
        return null;
    }

    switch (data.status) {
        case "VALID":
            return data;

        case "HIGH_RISK":
            throw new SslcommerzError("high_risk", msg`Payment cancelled due to high risk`);
        case "CANCELLED":
            throw new SslcommerzError("payment_cancelled", msg`Payment cancelled`);
        default:
            throw new SslcommerzError("other", failureToMessage(data));
    }
}
